import lodash from 'lodash'
import i18n, { langs } from './i18n'

export const getFullnameSorts = () => {
  const lang = i18n.locale
  const map = {
    [langs.enUS]: [
      { label: 'firstName', value: 'firstName' },
      { label: 'lastName', value: 'lastName' },
    ],
    [langs.zhCN]: [
      { label: 'lastName', value: 'lastName' },
      { label: 'firstName', value: 'firstName' },
    ],
  }
  const list = map[lang] || []
  return list
    .map((item) => {
      return Object.assign(item, {
        key: item.key || lodash.upperFirst(item.value),
      })
    })
    .map((item, index) => {
      return Object.assign(item, {
        isFirst: index === 0,
        isLast: index === list.length - 1,
        [`is${lodash.upperFirst(item.key)}`]: true,
      })
    })
}

export const displayI18nFullName = (firstName = '', lastName = '') => {
  const [f, l] = [firstName.trim(), lastName.trim()]
  const queue = []
  const separate = ' '
  if (i18n.locale === langs.zhCN) {
    queue.push(l, f)
  } else {
    queue.push(f, l)
  }
  return queue.join(separate).trim()
}

export default {
  getFullnameSorts,
  displayI18nFullName,
}
